/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { aiConfigsDeleteVariation } from "../../funcs/aiConfigsDeleteVariation.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteAIConfigVariationRequest$inboundSchema,
};

export const tool$aiConfigsDeleteVariation: ToolDefinition<typeof args> = {
  name: "delete-ai-config-variation",
  description: `Deletes an AI Config variation.`,
  scopes: ["write"],
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await aiConfigsDeleteVariation(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
